const {
  get,
  createInvariantWithPrefix,
  memoize
} = require('../library');
const {
  createBreakpoints
} = require('../core');
const defaultOptions = {
  errorPrefix: '[styled-breakpoints]: ',
  pathToMediaQueries: 'styled-breakpoints.breakpoints',
  defaultBreakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px'
  }
};
exports.createStyledBreakpoints = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  const invariant = createInvariantWithPrefix(options.errorPrefix);
  const getMediaQueriesFromTheme = _ref => {
    let {
      theme = {}
    } = _ref;
    const memoizedGet = memoize(get);
    const memoizedMediaQueries = memoizedGet(theme, options.pathToMediaQueries, options.defaultBreakpoints);
    return memoizedMediaQueries;
  };
  const withBreakpoints = fn => props => {
    const mediaQueriesFromTheme = getMediaQueriesFromTheme(props);
    const createMemoizedBreakpoints = memoize(createBreakpoints);
    const breakpoints = createMemoizedBreakpoints({
      breakpoints: mediaQueriesFromTheme,
      errorPrefix: options.errorPrefix
    });
    return fn(breakpoints);
  };
  const checkIsValidOrientation = x => {
    const validOrientations = x === 'portrait' || x === 'landscape';
    invariant(validOrientations, "`".concat(x, "` is invalid orientation. Use `landscape` or `portrait`."));
  };
  const withOrientation = (mediaQuery, orientation) => {
    checkIsValidOrientation(orientation);
    return "".concat(mediaQuery, " and (orientation: ").concat(orientation, ")");
  };
  const withOrientationOrNot = memoize((orientation, result) => orientation ? withOrientation(result, orientation) : result);
  const withMinAndMaxMedia = _ref2 => {
    let {
      min,
      max
    } = _ref2;
    return "@media (min-width: ".concat(min, ") and (max-width: ").concat(max, ")");
  };
  return {
    up: (name, orientation) => withBreakpoints(_ref3 => {
      let {
        up
      } = _ref3;
      return withOrientationOrNot(orientation, "@media (min-width: ".concat(up(name), ")"));
    }),
    down: (name, orientation) => withBreakpoints(_ref4 => {
      let {
        down
      } = _ref4;
      return withOrientationOrNot(orientation, "@media (max-width: ".concat(down(name), ")"));
    }),
    between: (min, max, orientation) => withBreakpoints(_ref5 => {
      let {
        between
      } = _ref5;
      return withOrientationOrNot(orientation, withMinAndMaxMedia(between(min, max)));
    }),
    only: (name, orientation) => withBreakpoints(_ref6 => {
      let {
        only
      } = _ref6;
      return withOrientationOrNot(orientation, withMinAndMaxMedia(only(name)));
    })
  };
};
exports.createTheme = breakpoints => ({
  'styled-breakpoints': {
    breakpoints
  }
});